<script setup lang="ts">
   import type { RouterLinkProps } from 'vue-router';
   import type { NuxtLinkProps } from '#app/components/nuxt-link';

   const props = defineProps<Omit<NuxtLinkProps, 'to'> & { to: RouterLinkProps['to'] }>();
</script>

<template>
   <NuxtLink v-bind="props">
      <slot />
   </NuxtLink>
</template>

<style scoped></style>
